// extracted by mini-css-extract-plugin
export default {"container":"manage-link_container__NsTXm","section":"manage-link_section__8p4RR"};